import type { AxiosError, InternalAxiosRequestConfig } from "axios";
import axios from "axios";

import { API_URL } from "~/constants/envConstants";
import { ACCESS_DENIED_PATH } from "~/routes/-route-constants/appRoutes.ts";
import { getAccessToken } from "~/services/tokenService";

declare module "axios" {
    interface AxiosRequestConfig {
        /** A request that handles its own 403 sets this, so the reply does not open the access-denied page. */
        skipAccessDeniedRedirect?: boolean;
    }
}

const baseConfig = {
    baseURL: API_URL,
    headers: { Accept: "application/json" },
};

const axiosApi = axios.create(baseConfig);

export const axiosApiNoInterceptors = axios.create(baseConfig);

axiosApi.interceptors.request.use((request: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    if (request.headers) {
        request.headers["Authorization"] = `Bearer ${getAccessToken()}`;
    }

    return request;
});

axiosApi.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
        if (error.response?.status === 403 && !error.config?.skipAccessDeniedRedirect) {
            window.location.href = ACCESS_DENIED_PATH;
        }

        return Promise.reject(error);
    },
);

export default axiosApi;
